import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class RolOperacionService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    verificarExitoOperacion(mensajes) {
        if (mensajes && mensajes.length > 0 && mensajes[0].tipo === 'SUCCESS')
            return true;
        return false;
    }
    operacionPermitida(inputParams, callback) {
        const self = this;
        this.gqlclient.query({
            query: gql `
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes } = response.data.rol_operacion.operacionPermitida;
            const allowed = self.verificarExitoOperacion(mensajes);
            callback(allowed);
        });
    }
}
RolOperacionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RolOperacionService_Factory() { return new RolOperacionService(i0.ɵɵinject(i1.GraphQLClient)); }, token: RolOperacionService, providedIn: "root" });
